//* Libraries imports
import { z } from "zod";

//*Schemas imports
import { phaseFormFieldDataSchema } from "./phaseForm";

export const formFieldSchema = phaseFormFieldDataSchema.extend({
  fieldId: z.string(),
});

export const formSchema = z.object({
  _id: z.string().optional(),
  fields: z.array(formFieldSchema),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
});
